'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("itTreeTableRowToggler", function () {
  var expandedClass = "fa-minus-square",
    collapsedClass = "fa-plus-square";
  return {
    restrict: "E",
    replace: true,
    scope: true,
    require: "^itTreeTableRow",
    template: '' + '<div class="row-toggler" ng-click="toggleChildren()">' + '   <i class="fa fa-plus-square"></i>' + '</div>',
    link: function link($scope, $el, $attrs, rowCtrl) {
      $scope.$watch(function () {
        return rowCtrl.isExpanded();
      }, function (expanded) {
        if (expanded) {
          $el.find("i").removeClass(collapsedClass).addClass(expandedClass);
        } else {
          $el.find("i").removeClass(expandedClass).addClass(collapsedClass);
        }
      });
      $scope.toggleChildren = function () {
        rowCtrl.toggleCollapse();
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/tree/itTreeTableRowToggler.js
// module id = 2823
// module chunks = 13